<mat-card class="no-overflow margin all custom-card">
  <!-- Header -->
  <mat-card-header class="reserve-header">
    <mat-card-title>Reserve Bitting</mat-card-title>
    <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>
  </mat-card-header>

  <!-- Content -->

  <mat-card-content class="padding all">
    <form [formGroup]="reserveForm" (keyup.enter)="reserve()">
      <!-- Reason -->
      <div class="row">
        <mat-form-field appearance="outline" class="fill padding sm right left">
          <mat-label
            [ngClass]="{
              'error-message': fieldHasError(reserveForm, 'reservationType'),
              focus: focus.reservationType
            }"
            >Reservation Type</mat-label
          >

          <div
            class="form-input"
            [ngClass]="{
              error: fieldHasError(reserveForm, 'reservationType'),
              disabled: false,
              'focus-border': focus.reservationType
            }"
          >
            <mat-icon class="search-icon">search</mat-icon>

            <input
              id="reservationType"
              placeholder="Enter Reservation Type name"
              formControlName="reservationType"
              (focus)="focusOn('reservationType')"
              (focusout)="focusOn('reservationType')"
              aria-describedby="reservationType errors"
              [matAutocomplete]="auto1"
              cdkFocusInitial
              matInput
            />

            <mat-icon *ngIf="fieldHasError(reserveForm, 'reservationType')">warning </mat-icon>
          </div>

          <!-- Errors -->
          <div *ngFor="let validation of errorMessages.reservationType" id="reservationTypeErrors">
            <div
              class="caption error-message"
              *ngIf="fieldHasErrorMessages(reserveForm, validation, 'reservationType')"
            >
              {{ validation.message }}
            </div>
          </div>

          <mat-autocomplete
            (optionSelected)="selectReservationType($event)"
            mat-autoselect="true"
            #auto1="matAutocomplete"
            [displayWith]="displayName"
          >
            <mat-option *ngFor="let reservationType of filteredReservationTypes | async" [value]="reservationType">
              {{ reservationType.description || reservationType.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <!-- Notes -->
      <div class="row">
        <mat-form-field class="fill padding sm right left" appearance="outline">
          <mat-label
            [ngClass]="{
              'error-message': fieldHasError(reserveForm, 'reservationNotes'),
              focus: focus.reservationNotes
            }"
            >Notes</mat-label
          >

          <div
            class="form-input"
            [ngClass]="{
              error: fieldHasError(reserveForm, 'reservationNotes'),
              disabled: false,
              'focus-border': focus.reservationNotes
            }"
          >
            <input
              id="reservationNotes"
              placeholder="Enter Reservation Notes"
              formControlName="reservationNotes"
              (focus)="focusOn('reservationNotes')"
              (focusout)="focusOn('reservationNotes')"
              aria-describedby="reservationNotes errors"
              matInput
            />

            <mat-icon *ngIf="fieldHasError(reserveForm, 'reservationNotes')">warning </mat-icon>
          </div>

          <!-- Errors -->
          <div *ngFor="let validation of errorMessages.reservationNotes" id="reservationNotesErrors">
            <div
              class="caption error-message"
              *ngIf="fieldHasErrorMessages(reserveForm, validation, 'reservationNotes')"
            >
              {{ validation.message }}
            </div>
          </div>
        </mat-form-field>
      </div>
    </form>
  </mat-card-content>

  <!-- Buttons -->
  <mat-card-actions>
    <div class="row flex-end">
      <button mat-raised-button (click)="close()">Cancel</button>
      <button mat-raised-button class="margin left" (click)="reserve()" [disabled]="!reserveForm.valid">Reserve</button>
    </div>
  </mat-card-actions>
</mat-card>
